import { TBillingContactInfo } from '@commenda/types/src/billing/types';
import { SWRFetcher } from '@commenda/utils';
import { Currency } from '@prisma/client';
import useSWR from 'swr';

interface IBillingContactProps {
  companyId: number;
  currency?: Currency;
}

export function useBillingContact({
  companyId,
  currency,
}: IBillingContactProps) {
  const queryParams = new URLSearchParams();
  if (currency) queryParams.append('currency', currency);

  const queryString = queryParams.toString();
  const url = `billing-new/contact-info?companyId=${companyId}${queryString ? `&${queryString}` : ''}`;

  return useSWR<TBillingContactInfo>(
    companyId ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );
}
